import { Request } from "./service"
import { Method, ServicePath} from '../utils'

export const authOidc =(data)=>{
    return Request(Method.POST, ServicePath.AuthOidc, data).then( res=>{
        return res
    }).catch(err=>{
        console.log(err)
        return err
    })
}

export const auth =(data)=>{
    return Request(Method.POST, ServicePath.AuthThinkAdmin, data).then( res=>{
        return res
    }).catch(err=>{
        console.log(err)
        return err
    })
}

export const getUser =()=>{
    return Request(Method.GET, ServicePath.GetUser, {}).then( res=>{
        return res
    }).catch(err=>{
        console.log(err)
        return err
    })
}